const TRANSLATION_NAMESPACE = "error:auth."

export const LOGIN_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}login-failed`
export const LOGOUT_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}logout-failed`
export const SIGNUP_USER_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}signup-user-failed`
